// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__7ApwV","title":"Info_title__K5jkq","selects":"Info_selects__2c3sc","requiredAsterisk":"Info_requiredAsterisk__q-xxl"};